<template>
  <div
    v-if="!isAuthLoading"
    id="app"
  >
    <div class="business-affiliate-wrapper">
      <Header v-if="isHeaderShown" />
      <div class="page-layout">
        <Sidebar v-if="isSidebarShown" />
        <div
          class="page-layout__content"
          :class="{'no-padding': !isSidebarShown}"
        >
          <ErrorState v-if="errorCode" />
          <router-view v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./js/app.js"></script>

<style lang="scss">
  @import '@blibli/blue-font/dist/_blue-font-blibli.scss';
  body {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    --font-family: #{$blu-font-family-body-text};
    font-family: var(--font-family);
  }
  .page-layout {
    display: flex;
    &__content {
      background-color: $blu-color-neutral-background-low;
      padding: 40px;
      flex: 1;
      min-width: 0;
      &.no-padding {
        padding: 0;
        background-color: $blu-color-neutral-background-default;
      }
    }
  }
</style>
